module.exports = __webpack_public_path__ + "static/media/shelter_beach_2.374d0e44.svg";